import React from 'react';
// import Image from 'next/image';
import { BzImage } from '@benzinga/image';
import { Image } from '@benzinga/article-manager';
import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface ImagePlacementProps {
  title?: string;
  caption?: string;
  primaryImage: Image;
}

export const ImagePlacement: React.FC<ImagePlacementProps> = ({ caption, primaryImage, title }) => {
  const alt = caption || '';
  if (primaryImage) {
    const primaryImageURL = primaryImage.url?.replace('//www.benzinga', '//cdn.benzinga');
    return (
      <Container className="image-placement">
        <div className="article-image bg-gray-100">
          <BzImage
            alt={alt}
            blurDataURL={`${primaryImageURL}?width=50`}
            height={378}
            layout="fill"
            objectFit="cover"
            preload={true}
            sizes="(max-width: 800px) 120px, (min-width: 800px) 400px" // this is a hack to handle viewport issues
            src={primaryImageURL}
            title={title}
            width={700}
          />
        </div>
        {caption && (
          <figcaption className="image-caption" dangerouslySetInnerHTML={{ __html: sanitizeHTML(caption) }} />
        )}
      </Container>
    );
  }

  return <div />;
};

const Container = styled.figure<{ $isAmp?: boolean }>`
  &.image-placement {
    margin: 0;
    margin-bottom: 1rem;
    .image-caption {
      padding: 0.25rem;
      color: ${({ theme }) => theme.colorPalette.gray700};
      border-bottom: 1px solid ${({ theme }) => theme.colorPalette.gray200};
      font-size: ${({ theme }) => theme.fontSize.sm};
    }
  }
  .article-image {
    width: 100%;
    padding-top: ${({ $isAmp }) => ($isAmp ? 'unset' : '43%')};
    overflow: hidden;
    position: relative;

    @media (max-width: 800px) {
      padding-top: calc(56.25% + 97px);
    }

    @media (max-width: 335px) {
      padding-top: calc(56.25% + 88px);
    }
  }

  .article-image img {
    width: 100%;
    height: auto;
    margin: auto;
    position: absolute;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
  }
`;
